import type { GetOnboardingWelcomeQuery } from "~/gql/queries/onboardingJourney.generated";

import { OnboardingSetupStage, OnboardingTrainingStatus } from "~/gql/graphqlBase.generated";
import onboardingTraining from "~/helpers/onboardingTraining";
import { useGetOnboardingWelcomeQuery } from "~/services/endpoints/apiEndpoints";

export interface OnboardingStanding {
	isStillOnboarding: boolean;
	onboardingSetup: OnboardingSetupStage;
	trainingComplete: boolean;
	welcome: GetOnboardingWelcomeQuery;
}

export interface UseOnboardingStandingReturn {
	isLoading: boolean;
	standing: OnboardingStanding | null;
}

const useOnboardingStanding = ({ skip }: { skip: boolean }): UseOnboardingStandingReturn => {
	const { data: welcome, isLoading } = useGetOnboardingWelcomeQuery(undefined, { skip });

	if (!welcome) return { isLoading, standing: null };
	const onboardingSetup = welcome.tenant?.onboardingSetup ?? OnboardingSetupStage.Unknown;
	const trainingComplete = onboardingTraining.isTrainingComplete({
		trainingStatus: welcome.tenant?.onboardingTraining ?? OnboardingTrainingStatus.Unknown
	});
	return {
		isLoading,
		standing: {
			isStillOnboarding: onboardingTraining.isStillOnboarding({ onboardingSetup, trainingComplete }),
			onboardingSetup,
			trainingComplete,
			welcome
		}
	};
};

export default useOnboardingStanding;
